
import Vue from "vue";
import store from "@/store";
import { mapState } from "vuex";
import { IRootState } from "@/store/types";
import { LOYALTY } from "@/store/loyalty";
import { IEarnRate, LoyaltySchemeType } from "@/store/loyalty/types";
import { getFlyBuysEarnRate, getAirpointsEarnRate } from "@/helpers/loyalty";

export default Vue.extend({
  props: {
    route: String
  },
  data() {
    return {
      isLoading: false,
      headers: [
        { text: "Account number", value: "accountNumber" },
        { text: "Account name", value: "customerName", sortable: false },
        { text: "Segment", value: "segment", sortable: false },
        { text: "Is eligible", value: "isEligible" },
        { text: "Level", value: "level" },
        { text: "Channel", value: "channels", sortable: false },
        {
          text: "Fly Buys earn rate / point",
          value: "flyBuysEarnRate",
          sortable: false
        },
        {
          text: "Airpoints earn rate / Airpoints $",
          value: "airpointsEarnRate",
          sortable: false
        }
      ]
    };
  },
  methods: {
    onItemClick(item: any) {
      this.$emit("click", item);
    },
    async onPagination(pagination: any) {
      (this as any).isLoading = true;

      await this.$store.dispatch(
        LOYALTY.NS(LOYALTY.ACTIONS.LOAD_ACCOUNT_OFFER_LIST),
        {
          pagination: this.pagination
        }
      );

      (this as any).isLoading = false;
    }
  },
  computed: {
    pagination: {
      get() {
        return store.state.loyalty.dataTables.accountOffers.pagination;
      },
      set(value: string) {
        this.$store.commit(
          LOYALTY.NS(LOYALTY.MUTATIONS.SET_ACCOUNT_OFFER_PAGINATION),
          value
        );
      }
    },
    ...mapState({
      accountOfferList: (state: IRootState) =>
        state.loyalty.accountOfferList.map(offer => ({
          ...offer,
          channelList: offer.channels.map(channel => channel.value).join(", "),
          flyBuysEarnRate: getFlyBuysEarnRate(offer),
          airpointsEarnRate: getAirpointsEarnRate(offer)
        })),
      paginationTotal: (state: IRootState) =>
        state.loyalty.accountOfferListPaginationTotal
    })
  }
});
